import React from 'react';

// Deposit details component that can be reused across different pages
const TransactionDetails = ({ 
 transactionType,
  quantity, 
  status, 
  chainType, 
  time, 
  depositAddress, 
  transactionHash 
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg overflow-hidden">
      <div className="p-4 border-b border-gray-200 dark:border-gray-700">
        <h2 className="text-lg font-semibold text-gray-800 dark:text-white">{transactionType} Details</h2>
      </div>
      
      <div className="p-4 space-y-4">
        {/* Quantity Section */}
        <div className="flex justify-between items-center">
          <span className="text-gray-600 dark:text-gray-300">Quantity</span>
          <div className="flex items-center space-x-2">
            <span className="font-bold text-lg text-gray-800 dark:text-white">
              {quantity} USDT
            </span>
            {status === 'Succeeded' && (
              <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
                {status}
              </span>
            )}
          </div>
        </div>

        {/* Deposit and Funding Account Section */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-gray-500 dark:text-gray-400">Deposit Account</p>
            <p className="text-gray-800 dark:text-white font-medium">-</p>
          </div>
          <div>
            <p className="text-sm text-gray-500 dark:text-gray-400">Funding Account</p>
            <p className="text-gray-800 dark:text-white font-medium">-</p>
          </div>
        </div>

        {/* Chain Type and Time */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-gray-500 dark:text-gray-400">Chain Type</p>
            <p className="text-gray-800 dark:text-white font-medium">{chainType}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500 dark:text-gray-400">Time</p>
            <p className="text-gray-800 dark:text-white font-medium">{time}</p>
          </div>
        </div>

        {/* Deposit Address */}
        <div>
          <p className="text-sm text-gray-500 dark:text-gray-400">Deposit Address</p>
          <div className="flex items-center justify-between bg-gray-100 dark:bg-gray-700 p-2 rounded-md">
            <span className="text-xs text-gray-600 dark:text-gray-300 truncate">
              {depositAddress}
            </span>
            <button 
              className="ml-2 text-gray-500 hover:text-gray-700 dark:hover:text-white"
              onClick={() => navigator.clipboard.writeText(depositAddress)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z" />
                <path d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z" />
              </svg>
            </button>
          </div>
        </div>

        {/* Transaction Hash */}
        <div>
          <p className="text-sm text-gray-500 dark:text-gray-400">Transaction Hash</p>
          <div className="flex items-center justify-between bg-gray-100 dark:bg-gray-700 p-2 rounded-md">
            <span className="text-xs text-gray-600 dark:text-gray-300 truncate">
              {transactionHash}
            </span>
            <button 
              className="ml-2 text-gray-500 hover:text-gray-700 dark:hover:text-white"
              onClick={() => navigator.clipboard.writeText(transactionHash)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z" />
                <path d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z" />
              </svg>
            </button>
          </div>
        </div>

        {/* Blockchain Explorer Button */}
        <div className="mt-4">
          <button 
            className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 transition-colors"
            onClick={() => window.open('https://example.com/blockchain-explorer', '_blank')}
          >
            View in Blockchain Explorer
          </button>
        </div>
      </div>
    </div>
  );
};

// Default props for demonstration
TransactionDetails.defaultProps = {
transactionType:'Deposit',
  quantity: '2,000',
  status: 'Succeeded',
  chainType: 'TRC20',
  time: '2025-03-02 14:37:46',
  depositAddress: 'TJFyV8HeiMayfmKXJTpLXaLtREquPJGt7',
  transactionHash: '2136e6f3b99bf9a509d8e956ad944e5b3465e0e6afb2996f0025defbb64671'
};

export default TransactionDetails;